/* eslint-disable */
import { v4 as uuid } from 'uuid';
/**
 *  All Dashboard Routes
 *
 *  Understanding name/value pairs for Dashboard routes
 *
 *  Applicable for main/root/level 1 routes
 *  icon 		: String - It's only for main menu or you can consider 1st level menu item to specify icon name.
 * 				: Object - Icon as an object added from v1.4.0.
 * 				-> You choose any icon from https://feathericons.com/
 *
 *  Applicable for main/root/level 1 and subitems routes
 * 	id 			: Number - You can use uuid() as value to generate unique ID using uuid library, you can also assign constant unique ID for react dynamic objects.
 *  title 		: String - If menu contains childern use title to provide main menu name.
 *  badge 		: String - (Optional - Default - '') If you specify badge value it will be displayed beside the menu title or menu item.
 * 	badgecolor 	: String - (Optional - Default - 'primary' ) - Used to specify badge background color.
 *
 *  Applicable for subitems / children items routes
 *  name 		: String - If it's menu item in which you are specifiying link, use name ( don't use title for that )
 *  children	: Array - Use to specify submenu items
 *
 *  Used to segrigate menu groups
 *  grouptitle : Boolean - (Optional - Default - false ) If you want to group menu items you can use grouptitle = true,
 *  ( Use title : value to specify group title  e.g. COMPONENTS , DOCUMENTATION that we did here. )
 *
 */

// import MDI icons
import Icon from '@mdi/react';
import { mdiTrello, mdiCalendar } from '@mdi/js';

export const DashboardMenuSysadmin = [
	{
		id: uuid(),
		title: 'Dashboard',
		icon: 'home',
		children: [
			{ id: uuid(), link: '/dashboard/overview', name: 'Übersicht' }
		]
	},
	// -- Flows -- //
	{
		id: uuid(),
		title: 'Flows',
		icon: 'git-pull-request',
		children: [
			{
				id: uuid(),
				link: '/dashboard/flows/returns',
				name: 'Rücksendungen'
			}
		]
	},
	// -- Marketplace -- //
	{
		id: uuid(),
		title: 'Marketplace',
		icon: 'shopping-bag',
		children: [
			{
				id: uuid(),
				link: '/dashboard/marketplace/flows',
				name: 'Flows'
			}
		]
	},
	// -- Einstellungen für KEYUSER -- //
	{
		id: uuid(),
		title: 'Einstellungen',
		grouptitle: true
	},
	{
		id: uuid(),
		title: 'Einstellungen',
		icon: 'settings',
		link: '/settings/general'
	},
	// -- Globale Einstellungen für SYSADMIN -- //
	{
		id: uuid(),
		title: 'Administration',
		icon: 'sliders',
		children: [
			{ id: uuid(), link: '/administration/connector/settings', name: 'Connector' },
			{ id: uuid(), link: '/administration/cron/settings', name: 'Cron Jobs' },
			{ id: uuid(), link: '/administration/email/settings', name: 'E-Mail' },
			{ id: uuid(), link: '/administration/logs', name: 'Logs' },
			{ id: uuid(), link: '/administration/marketing/settings', name: 'Marketing' }
		]
	},
	{
		id: uuid(),
		title: 'Hilfe',
		grouptitle: true
	},
	// -- Help Center and Changelog -- //
	{
		id: uuid(),
		title: 'Help Center',
		icon: 'help-circle',
		link: '/marketing/help-center/'
	},
	{
		id: uuid(),
		title: 'Changelog',
		icon: 'git-pull-request',
		link: '/dashboard/changelog',
		badge: 'v0.0.4'
	}
];

export default DashboardMenuSysadmin;
